import React, {FunctionComponent} from 'react';

import FilterPanel from './filter-panel/filter-panel';
import FilterIconButton from './filter-icon-button/filter-icon-button';

import styles from './filter.module.css';
import {useFilters} from '../../../hooks/useFilters';

const Filter: FunctionComponent = () => {
  const {filterIsOpen} = useFilters();

  return (
    <div className={styles.filter}>
      <FilterIconButton />
      {filterIsOpen && <FilterPanel />}
    </div>
  );
};
export default Filter;
